export default __webpack_public_path__ + "static/job-test-prep-7ce9e9e4c612072d28a356277e607606.png";